"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDefaultFilter = exports.DefaultFilterSingleDropdown = exports.DefaultFilterMultiDropdown = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var _menu_1 = tslib_1.__importDefault(require("../_components/_menu"));
var button_1 = tslib_1.__importDefault(require("../button"));
var checkbox_1 = tslib_1.__importDefault(require("../checkbox"));
// type FilterDropdown = ValuesType<ColumnsType<any>>['filterDropdown'];
var DefaultFilterMultiDropdown = function (_a) {
    var filters = _a.filters, confirm = _a.confirm, setSelectedKeys = _a.setSelectedKeys, selectedKeys = _a.selectedKeys, 
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    _b = _a.clearFilters, 
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    clearFilters = _b === void 0 ? function () { } : _b, visible = _a.visible, filteredValue = _a.filteredValue;
    var _c = tslib_1.__read((0, react_1.useState)(selectedKeys), 2), localSelectedKeys = _c[0], setLocalSelected = _c[1];
    var filterClick = (0, react_1.useCallback)(function (filter) {
        if (filter.value === '' && localSelectedKeys.includes('')) {
            setLocalSelected([]);
            return;
        }
        if (filter.value === '') {
            setLocalSelected(['']);
            return;
        }
        if (localSelectedKeys.includes('') && filter.value !== '') {
            // eslint-disable-next-line consistent-return
            return setLocalSelected([filter.value]);
        }
        if (localSelectedKeys.includes(filter.value)) {
            setLocalSelected(localSelectedKeys.filter(function (selected) { return selected !== filter.value; }));
        }
        else {
            setLocalSelected(tslib_1.__spreadArray(tslib_1.__spreadArray([], tslib_1.__read(localSelectedKeys), false), [filter.value], false));
        }
    }, [localSelectedKeys]);
    (0, react_1.useEffect)(function () {
        if (visible && filteredValue) {
            setLocalSelected(filteredValue);
        }
    }, [visible, filteredValue]);
    return (react_1.default.createElement(_menu_1.default, { prefixCls: "anq-dropdown-menu", className: "anq-dropdown-multi" },
        filters.map(function (filter, index) { return (
        // eslint-disable-next-line react/jsx-no-bind
        react_1.default.createElement(_menu_1.default.Item, { onClick: function () { return filterClick(filter); }, key: "".concat(filter.value).concat(index) },
            react_1.default.createElement(checkbox_1.default, { checked: localSelectedKeys.includes(filter.value) }),
            react_1.default.createElement("span", null, filter.text))); }),
        react_1.default.createElement("div", { className: "anq-table-dropdown-btns" },
            react_1.default.createElement(button_1.default, { type: "primary", size: "small", 
                // eslint-disable-next-line react/jsx-no-bind
                onClick: function () {
                    var nextSelectKeys = localSelectedKeys.filter(function (select) { return select !== ''; });
                    setSelectedKeys(nextSelectKeys);
                    if (nextSelectKeys.length === 0) {
                        clearFilters();
                    }
                    else {
                        confirm({ closeDropdown: true });
                    }
                } }, "\u786E\u5B9A"),
            react_1.default.createElement(button_1.default, { style: { marginLeft: '8px' }, type: "default", size: "small", 
                // eslint-disable-next-line react/jsx-no-bind
                onClick: function () {
                    setSelectedKeys(selectedKeys);
                    confirm({ closeDropdown: true });
                } }, "\u53D6\u6D88"))));
};
exports.DefaultFilterMultiDropdown = DefaultFilterMultiDropdown;
var DefaultFilterSingleDropdown = function (_a) {
    var filters = _a.filters, confirm = _a.confirm, clearFilters = _a.clearFilters, setSelectedKeys = _a.setSelectedKeys, filteredValue = _a.filteredValue;
    var selectedKeys = (0, react_1.useMemo)(function () {
        if (Array.isArray(filteredValue)) {
            return filteredValue.map(function (item) { return "".concat(item); });
        }
        return undefined;
    }, [filteredValue]);
    return (react_1.default.createElement(_menu_1.default, { prefixCls: "anq-dropdown-menu", selectedKeys: selectedKeys }, filters.map(function (filter) {
        return (react_1.default.createElement(_menu_1.default.Item, { key: "".concat(filter.value), 
            // eslint-disable-next-line react/jsx-no-bind
            onClick: function () {
                if (filter.value) {
                    setSelectedKeys([filter.value]);
                    confirm({ closeDropdown: true });
                }
                else {
                    clearFilters && clearFilters();
                }
            } }, filter.text));
    })));
};
exports.DefaultFilterSingleDropdown = DefaultFilterSingleDropdown;
function transformDefaultFilter(column) {
    if (!column.filters) {
        return column;
    }
    if (column.filters.every(function (filter) { return filter.value; })) {
        column.filters = tslib_1.__spreadArray([{ text: '不限', value: '' }], tslib_1.__read(column.filters), false);
    }
    var multiDropdown = function (props) { return (react_1.default.createElement(exports.DefaultFilterMultiDropdown, tslib_1.__assign({}, props, { filteredValue: column.filteredValue }))); };
    var singleDropdown = function (props) { return (react_1.default.createElement(exports.DefaultFilterSingleDropdown, tslib_1.__assign({}, props, { filteredValue: column.filteredValue }))); };
    if (column.filterMultiple !== false) {
        column.filterDropdown = column.filterDropdown || multiDropdown;
    }
    else {
        column.filterDropdown = column.filterDropdown || singleDropdown;
    }
    return column;
}
exports.transformDefaultFilter = transformDefaultFilter;
//# sourceMappingURL=FilterDropdown.js.map